import React from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import { Field, getIn } from 'formik';
import useTranslation from 'next-translate/useTranslation';

interface ISelectFieldProps {
  as?: any;
  xs?: number;
  sm?: number;
  md?: number;
  lg?: number;
  xl?: number;
  label: string;
  name: string;
  inputGroupPrepend?: any;
  onChange?: any;
  disabled?: boolean;
  children: React.ReactNode;
  defaultValue?: any;
  onBlur?: (event: React.FocusEvent<any>) => void;
}

export const SelectField = ({ label, name, inputGroupPrepend, disabled = false, children, ...restProps }: ISelectFieldProps) => {
  const { t } = useTranslation('form-errors');

  return (
    <Field name={name}>
      {({ field, form }: { field: any; form: any }) => {
        const feedback = getIn(form.errors, field.name);
        const isTouched = getIn(form.touched, field.name);
        const isValid = isTouched && !getIn(form.errors, field.name);
        const isInvalid = !!feedback;

        const handleChange = (event: React.FormEvent<HTMLFormElement>) => {
          field.onChange(event);
          form.setFieldTouched(field.name);
          form.validateField(field.name);

          if (typeof restProps.onChange === 'function') {
            restProps.onChange(event);
          }
        };

        return (
          <Form.Group>
            <Form.Label className={isInvalid ? 'text-danger' : ''}>{label}</Form.Label>
            <InputGroup>
              {inputGroupPrepend}
              <Form.Control
                {...field}
                isValid={isValid}
                disabled={disabled}
                isInvalid={isInvalid}
                feedback={feedback}
                as="select"
                data-testid={field.name}
                value={field.value}
                {...(restProps.onChange && { onChange: handleChange })}
                {...(restProps.onBlur && { onBlur: restProps.onBlur })}
              >
                {children}
              </Form.Control>
              <Form.Control.Feedback type="invalid">{feedback && t(feedback)}</Form.Control.Feedback>
            </InputGroup>
          </Form.Group>
        );
      }}
    </Field>
  );
};
